import { clearVoicemailCache } from './voicemailStorage';
import { clearCallHistoryCache } from './callHistoryStorage';
import { queueService } from '../../interpreter-queue/InterpreterQueueService';
import { forgetInterpreterRequest } from '../../interpreter-queue/lastInterpreterRequest';
import { resetInterpreterQueueMiddleware } from '../../interpreter-queue/middleware';
import { initializeNativeSignOut, startNativeSignOut } from '../../vrs-auth/nativeSignOut';
import { forgetCallHandles } from '../call-integration/callHandles';
import { beginPrivateJobDraftCleanup } from './clearPrivateJobDrafts';
import { beginSchedulingCacheCleanup } from './components/vri/vriSchedulingCache';
import { beginUsageCacheCleanup } from './components/vri/vriUsageCache';
import { beginJobClientSessionCleanup } from './components/vri/vriJobsSession';
import { beginOperatorInstructionsCleanup } from './operatorInstructions';
import { mobileLog } from './logging';
import { forgetPreviewForRoom } from './previewResume';
export { MOBILE_SIGN_OUT_STORAGE_KEYS } from '../../vrs-auth/nativeSignOut';
/** One failed queue send must not prevent disconnection, draft fencing, or cleanup. */
function retireMobileSession() {
    const actions = [
        beginPrivateJobDraftCleanup, beginOperatorInstructionsCleanup,
        beginSchedulingCacheCleanup, beginUsageCacheCleanup, beginJobClientSessionCleanup,
        () => queueService.endActiveCall(),
        // Out of the queue first: a phone that rings offers while off the
        // screen would otherwise stay in it (vrs-server/ws/interpreter-standby.js).
        () => queueService.leaveQueueForSignOut(), () => queueService.disconnect(),
        resetInterpreterQueueMiddleware, clearCallHistoryCache, clearVoicemailCache,
        () => forgetPreviewForRoom(), forgetCallHandles,
        // "Try again" never sends the previous person's request (lastInterpreterRequest.ts).
        forgetInterpreterRequest
    ];
    actions.forEach(action => {
        try {
            void Promise.resolve(action()).catch(() => mobileLog('warn', 'mobile_sign_out_retirement_failed', {}));
        }
        catch {
            mobileLog('warn', 'mobile_sign_out_retirement_failed', {});
        }
    });
}
export function initializeMobileSignOut() {
    return initializeNativeSignOut(retireMobileSession);
}
export function signOutMobileUser(endMedia) {
    return startNativeSignOut(() => {
        retireMobileSession();
        try {
            void Promise.resolve(endMedia?.()).catch(() => mobileLog('warn', 'mobile_sign_out_media_cleanup_failed', {}));
        }
        catch {
            mobileLog('warn', 'mobile_sign_out_media_cleanup_failed', {});
        }
    });
}
